module.exports = __webpack_public_path__ + "img/avilon.977825fe.jpg";